// extracted by mini-css-extract-plugin
export var dropdownIcon = "_s4-6";
export var imgContainer = "_s4-3";
export var menuIcon = "_s4-5";
export var pillWrapper = "_s4-2";
export var pillsContainer = "_s4-1";
export var subscriptionCard = "_s4-0";
export var subscriptionLogo = "_s4-4";